import { fork } from 'redux-saga/effects';

import deviceCredentialsSagas from 'components/DeviceCredentials/sagas';
import settingsDiscoverySeedSagas from 'components/DiscoverySeed/sagas';
import jobManagementSagas from 'containers/App/Header/JobManagement/sagas';
import downloadReport from 'containers/DownloadReport/sagas';
import downloadSiteReport from 'containers/DownloadSiteReport/sagas';
import errorBoundarySagas from 'containers/ErrorBoundary/sagas';
import fileUploadOverlaySagas from 'containers/FileUploadOverlay/sagas';
import overviewSagas from 'pages/Dashboard/Overview/sagas';
import maintenance from 'pages/Maintenance/sagas';
import administrationLdapSettingsSagas from 'pages/Settings/Administration/LdapSettings/sagas';
import settingsConfigurationManagementSagas from 'pages/Settings/ConfigurationManagement/sagas';
import settingsAdvancedSagas from 'pages/Settings/DiscoverySnapshots/GlobalDiscoveryConfiguration/sagas';
import certificationAuthoritiesSagas from 'pages/Settings/System/BackupMaintenance/CertificationAuthorities/sagas';
import settingsSystemBackupMaintenanceSagas from 'pages/Settings/System/BackupMaintenance/sagas';
import snapshotManagementSagas from 'pages/SnapshotManagement/sagas';
import supportDiagnosticsSagas from 'pages/Support/SendDiagnostics/sagas';
import supportVpnSagas from 'pages/Support/Vpn/sagas';
import { requestSagas } from 'utils/request/sagas';

export default function* rootSaga() {
  yield fork(certificationAuthoritiesSagas);
  yield fork(downloadReport);
  yield fork(downloadSiteReport);
  yield fork(errorBoundarySagas);
  yield fork(fileUploadOverlaySagas);
  yield fork(jobManagementSagas);
  yield fork(maintenance);
  yield fork(overviewSagas);
  yield fork(requestSagas);
  yield fork(settingsSystemBackupMaintenanceSagas);
  yield fork(settingsConfigurationManagementSagas);
  yield fork(settingsAdvancedSagas);
  yield fork(deviceCredentialsSagas);
  yield fork(settingsDiscoverySeedSagas);
  yield fork(snapshotManagementSagas);
  yield fork(supportDiagnosticsSagas);
  yield fork(supportVpnSagas);
  yield fork(administrationLdapSettingsSagas);
}
